const adminiUserMage = r => require.ensure([], () => r(require('@/page/adminiUserMage/adminiUserMage')), 'adminiUserMage');
const AdminiUserList = r => require.ensure([], () => r(require('@/page/adminiUserMage/adminiUserList/AdminiUserList')), 'AdminiUserList');
const addAdminiUser = r => require.ensure([], () => r(require('@/page/adminiUserMage/adminiUserList/addAdminiUser')), 'addAdminiUser');
const editAdminiUser = r => require.ensure([], () => r(require('@/page/adminiUserMage/adminiUserList/editAdminiUser')), 'editAdminiUser');
const AdminiUserDetail = r => require.ensure([], () => r(require('@/page/adminiUserMage/adminiUserList/AdminiUserDetail')), 'AdminiUserDetail');
const help= r => require.ensure([], () => r(require('@/page/help/help')), 'help');

const expertInfoRouter = {
  path: '',
  name: '用户管理',
  component: adminiUserMage,
  meta: {
    icon: 'expertInfo',
    right: [],
    isShowMenu: true,
  },
  children: [{
    path: '/AdminiUserList',
    component: AdminiUserList,
    name: '用户管理',
    meta: {
      right: ['用户管理'],
      isShowMenu: true
    },
  }, {
    path: '/addAdminiUser',
    component: addAdminiUser,
    name: '用户新增',
    meta: {
      right: ['用户新增'],
      isShowMenu: true,
      keepAlive:true,
    },
  }, {
    path: '/editAdminiUser',
    component: editAdminiUser,
    name: '用户编辑',
    meta: {
      right: ['用户编辑'],
      isShowMenu: true,
      keepAlive:true,
    },
  },
  {
    path: '/help',
    component: help,
    name: '操作手册配置界面',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive:true,
    },
  }, {
    path: '/AdminiUserDetail',
    component: AdminiUserDetail,
    name: '用户详情',
    meta: {
      right: ['用户详情'],
      isShowMenu: true,
      keepAlive:true,
    },
  }]
};
export default expertInfoRouter;